import { useQuery } from '@tanstack/react-query';

import { JobState } from '@/models/DocumentProcessingJob';
import { getDocumentProcessingJob } from '@/services/api/document-processing-jobs/api';

const isJobComplete = (state: JobState | undefined) =>
  state === JobState.completed || state === JobState.failed;

export const useGetDocumentProcessingJobById = (
  jobId: string,
  { poll = false, interval = 5000 },
) => {
  const { data, error, isLoading, isFetching } = useQuery({
    queryKey: ['document-processing-job', jobId],
    queryFn: () => getDocumentProcessingJob(jobId),
    enabled: Boolean(jobId),
    refetchInterval: poll
      ? (query) => (isJobComplete(query.state?.data?.state) ? false : interval)
      : false,
    refetchIntervalInBackground: poll,
  });

  return {
    documentProcessingJob: data,
    error,
    isLoading: isLoading || isFetching,
  };
};
